export function initEventOrganisationDataStorage() {
  return {
    /**
     * Stores organisation domain data in localStorage.
     * If domain values exist, they are stored; if not, they are removed from localStorage.
     *
     * @param {Object} organisation - The organisation object containing domain information
     * @param {string} [organisation.photo_share_domain] - Photo share domain URL
     * @param {string} [organisation.webapp_domain] - Webapp domain URL
     */
    storeEventOrganisationData(organisation) {
      if (!organisation || typeof organisation !== 'object') {
        return;
      }

      const domainFields = [
        { key: 'photo_share_domain', value: organisation.photo_share_domain },
        { key: 'webapp_domain', value: organisation.webapp_domain }
      ];

      domainFields.forEach(({ key, value }) => {
        if (value && typeof value === 'string' && value.trim()) {
          localStorage.setItem(key, value.trim());
        } else {
          localStorage.removeItem(key);
        }
      });
    },
    getPhotoShareDomainFromStorage() {
      return localStorage.getItem('photo_share_domain');
    },
    getWebappDomainFromStorage() {
      return localStorage.getItem('webapp_domain');
    },

    hasPhotoShareDomain() {
      return Boolean(localStorage.getItem('photo_share_domain'));
    },
    hasWebappDomain() {
      return Boolean(localStorage.getItem('webapp_domain'));
    },
  };
}
